<template>
	<div>
  	<button v-show="buttonText && !loading && !loaded" class="uk-button uk-button-secondary uk-width-1-1 uk-border-rounded" @click="handleClick">
    	{{ buttonText }}
  	</button>
		<div><loading-indicator v-show="loading" /></div>
		<div v-html="htmlData"></div>
	</div>
</template>

<script>

import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },
  props: {
		url: {
			type: String,
			required: true
		},
		params: {
			type: Object,
			default: {}
		},
    buttonText: {
      type: String,
			default: null,
      required: false
    },
		targetElement: {
			type: String,
			required: false
		}
  },
	data() {
		return {
			loading: false,
			loaded: false,
			htmlData: null
		}
	},
	mounted() {
		var app = this.$root;
		var component = this;
		component.init();    
	},	
  methods: {
		init() {		
			this.$logger('app/component/async-loader/init')
			var component = this;	
			
			if(!component.buttonText) {
				component.loadContent();
			}
		},
    handleClick() {
			this.loadContent();
    },		
		loadContent() {

			var component = this;

			component.$logger('app/components/async-loader/loadContent/url:' + component.url);
			
			component.loading = true;

			axios({
				method: 'get',
				url: component.url,
				params: component.params
			})
			.then(function (response) {
				
				if(component.targetElement) {
					document.getElementById(component.targetElement).innerHTML = response.data;
				} else {
					component.htmlData = response.data;
				}	

				component.loading = false;		
				component.loaded = true;	  	
			})
			.catch(function (e) {
				if(e) {
					console.error(e);
				}
			});		

		}
  }
};
</script>

<style scoped>
</style>
